<template>
  <div class="contact">
    <div v-if="isMobile" class="mobile-return" @click="$router.go(-1)">X</div>
    <div :class="isMobile?'mobile-main-content':'main-content'">
      <div class="info-left">
        <!-- <img src="../assets/img/afmLocation.png"/> -->
        <google-map ref="google-map"/>
        <div class="location">
          <h2>LOCATION</h2>
          <ul>
            <li>3390 South State Street, #11 (Inside of Chinatown Center)</li>
            <li>Salt Lake City, Utah 84115</li>
            <li>Monday – Sunday : 9:30AM – 8:30PM</li>
            <li>7 days a week, 365 days a year</li>
            <li>Open on Thanksgiving, Christmas, New Years and all other holidays.</li>
            <li>Contact: 801-906-8788</li>
          </ul>
        </div>
      </div>
      <div class="info-right">
        <div>
          <h2>{{ $t('contact_us') }}</h2>
          <!-- <p> {{ $t('wechat') }} ID：SHOPAFM<br>
              help@shopafm.com<br>
              425-357-2992<br>
              {{ $t('days_a_week') }}<br>
              10am--7pm<br>
          </p> -->
        </div>
        <!-- <div class="social-icons">
          <img class="icon" src="../assets/img/weChatIcon.svg"/>
          <img class="icon" src="../assets/img/instagramIcon.svg"/>
          <img class="icon" src="../assets/img/facebookIcon.svg"/>
        </div> -->
      <div v-show="postContactSuccess" class="contact-success">
        Contact Form Submitted!
      </div>
        <div class="help-form" v-show="!postContactSuccess">
          <!-- <div class="input-item">
            <p class="input-title">{{ $t('name') }}</p>
            <input class="input-box" :placeholder="$t('name')" v-model="form.Name" @keyup="checkForm"/>
            <span v-if="error.Name" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
              {{error.Name}}
            </span>
          </div> -->
          <div class="input-item">
            <p class="input-title">{{ $t('firstName') }}</p>
            <input class="input-box" :placeholder="$t('firstName')" v-model="form.FirstName" @keyup="checkForm"/>
            <span v-if="error.FirstName" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
              {{error.FirstName}}
            </span>
          </div>
          <div class="input-item">
            <p class="input-title">{{ $t('lastName') }}</p>
            <input class="input-box" :placeholder="$t('lastName')" v-model="form.LastName" @keyup="checkForm"/>
            <span v-if="error.LastName" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
              {{error.LastName}}
            </span>
          </div>
            <div class="input-item">
              <p class="input-title">{{ $t('email') }}</p>
              <input class="input-box" :placeholder="$t('email')" v-model="form.Email" @keyup="checkForm"/>
                <span v-if="error.Email" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                  {{error.Email}}
                </span>
            </div>
            <div class="input-item">
              <p class="input-title">{{$t('phone_optional')}}</p>
              <input class="input-box" placeholder="(000)-000-0000" v-model="form.PhoneNumber" @keyup="checkForm"
            />
            <span v-if="error.PhoneNumber" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
              {{error.PhoneNumber}}
            </span>
            </div>
          <div class="input-item">
            <p class="input-title">{{ $t('message') }}</p>
            <!-- <input
              class="input-box"
              :placeholder="$t('message')"
              v-model="form.Message"
              @keyup="checkForm"
          /> -->
            <textarea 
              class="input-box"
              :placeholder="$t('message')"
              v-model="form.Message"
              @keyup="checkForm"
            />
          <span v-if="error.Message" class='error-message'>
            <svg class="icon icon-error">
              <path
                d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
            </svg>
            {{error.Message}}
          </span>
          </div>
          <div class="button-cont">
            <button @click="sendContactUsForm($event)">{{$t('send')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { validateEmail, validatePhoneNumber } from "../../config/validation";
import GoogleMap from '../components/GoogleMap/GoogleMap'
export default {
  name: "contact",
  components: {GoogleMap},
  data(){
    return{
      form: {
        // Name: '',
        FirstName: '',
        LastName: '',
        Email: '',
        PhoneNumber: '',
        Message: '',
      },
      error:{
        // Name: '',
        FirstName: '',
        LastName: '',
        Email: '',
        PhoneNumber: '',
        Message: '',
      },
    }
  },
  methods: {
    ...mapActions('contact', ['postContact']),
    ...mapMutations('contact', ['resetPostContact']),
    sendContactUsForm(e) {
      e.preventDefault();
      this.submit = false;
      if (
        // !this.error.Name && 
        !this.error.FirstName && 
        !this.error.LastName && 
        !this.error.Email && 
        !this.error.PhoneNumber && 
        !this.error.Message
      ) {
        this.form.Name=this.form.FirstName+' '+this.form.LastName
        this.postContact(this.form)
      }
    },
    async checkForm() {
      // if (!this.form.Name){
      //   this.error.Name = 'Name cannot be empty.'
      // } else {
      //   this.error.Name = '';
      // }
      if (!this.form.FirstName){
        this.error.FirstName = 'First Name cannot be empty.'
      } else {
        this.error.FirstName = '';
      }
      if (!this.form.LastName){
        this.error.LastName = 'Last Name cannot be empty.'
      } else {
        this.error.LastName = '';
      }
      if (validateEmail(this.form.Email)){
        this.error.Email = 'Email is invalid.'
      } else {
        this.error.Email = '';
      }
      if (!this.form.Message) {
        this.error.Message = 'Message cannot be empty.'
      } else {
        if(this.form.Message.length>200){
          this.error.Message = 'Message cannot exceed 200 words.'
        }else{
          this.error.Message = '';
        }
      }
      const PhoneNumber = this.form.PhoneNumber
      if (PhoneNumber && validatePhoneNumber(PhoneNumber)) {
        this.error.PhoneNumber = 'Phone Number is invalid.'
      } else {
        this.error.PhoneNumber = '';
      }
    },
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    postContactSuccess: state => state.contact.postContactSuccess,
    windowWidth: state => state.navbar.windowWidth,
    isMobile () {
      return this.windowWidth < 800
    },
  }),
  watch: {
    postContactSuccess(newValue, oldValue) {
      if (newValue == true) {
        let that = this;
        this.submit = true;
        // this.form.Name = '';
        this.form.FirstName = '';
        this.form.LastName = '';
        this.form.Email = '';
        this.form.PhoneNumber = '';
        this.form.Message = '';
        setTimeout(function(){
          that.resetPostContact(false)
        }, 3000);

      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/contact.less";
</style>



// WEBPACK FOOTER //
// src/view/contact.vue